import React, { useId } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  hint,
  style,
  id,
  ...rest
}) => {
  // Ties the label to the field, so clicking it focuses the input and a
  // screen reader announces it.
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {label && (
        <label
          htmlFor={inputId}
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: 'var(--neutral-700)',
          }}
        >
          {label}
        </label>
      )}
      <input
        {...rest}
        id={inputId}
        style={{
          padding: '10px 14px',
          fontSize: 14,
          fontFamily: 'var(--font-family)',
          color: 'var(--neutral-800)',
          background: 'var(--neutral-100)',
          border: `1px solid ${error ? 'var(--danger-600)' : 'var(--neutral-300)'}`,
          borderRadius: 'var(--radius-md)',
          outline: 'none',
          height: 40,
          transition: 'border 150ms ease',
          ...style,
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = 'var(--blue-600)';
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = error
            ? 'var(--danger-600)'
            : 'var(--neutral-300)';
        }}
      />
      {(error || hint) && (
        <span
          style={{
            fontSize: 12,
            color: error ? 'var(--danger-600)' : 'var(--neutral-500)',
          }}
        >
          {error || hint}
        </span>
      )}
    </div>
  );
};